import React from 'react'
// libs
import { useApolloClient } from './useApolloClient'
// graphql
import { POWER_BI_CREATE_REPORT_MUTATION, POWER_BI_TOKEN_CREATE_MUTATION } from 'graphql/powerBI/mutations'
// types
import { PowerBiTokenAcessLevels } from 'types/graphql'
// utils
import get from 'lodash/get'
import { handleError } from 'utils/errors/handlers'

export const useSetPowerBIToken = ({ reportId = null, workspaceId, isCreate = false, isEdit = false }) => {
  const [accessToken, setAccessToken] = React.useState<string>('')

  const { client } = useApolloClient()

  const setPowerBIToken = async () => {
    try {
      const token = get(
        await client.mutate({
          mutation: POWER_BI_TOKEN_CREATE_MUTATION,
          variables: {
            input: {
              reportId,
              workspaceId,
              accessLevel: isEdit ? PowerBiTokenAcessLevels.Edit : PowerBiTokenAcessLevels.View
            }
          }
        }),
        'data.powerBITokenCreate.data.token'
      )

      setAccessToken(token)
    } catch (e) {
      handleError(e, 'useSetPowerBIToken.setPowerBIToken')
    }
  }

  const setPowerBICreateToken = async () => {
    try {
      const token = get(
        await client.mutate({
          mutation: POWER_BI_CREATE_REPORT_MUTATION,
          variables: {
            input: {
              workspaceId
            }
          }
        }),
        'data.powerBIReportCreate.data.token'
      )

      setAccessToken(token)
    } catch (e) {
      handleError(e, 'useSetPowerBIToken.setPowerBICreateToken')
    }
  }

  React.useEffect(() => {
    if (isCreate) {
      setPowerBICreateToken()
    } else if (reportId) {
      setPowerBIToken()
    }
  }, [reportId])

  return accessToken
}
